import Bugsnag from "@bugsnag/js";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
} from "use-query-params";

import axiosInstance from "../axiosInstance";
import { addToast, setVerifyingNsp } from "../Store/Actions";
import URL from "../urls";

export const NspStatusViews = {
  CONFIRMATION_MODAL: "CONFIRMATION_MODAL",
  NSP_MODAL: "NSP_MODAL",
};

const { CONFIRMATION_MODAL, NSP_MODAL } = NspStatusViews;

const useNspVerification = ({ isCoupleTherapist } = {}) => {
  const dispatch = useDispatch();

  const [activeNspModal, setActiveNspModal] = useState(null);

  const [queryParams, setQueryParams] = useQueryParams({
    clientId: NumberParam,
    clientName: StringParam,
    showNspModal: BooleanParam,
  });

  const { clientId, showNspModal } = queryParams;

  useEffect(() => {
    if (isCoupleTherapist) {
      if (!clientId || !showNspModal) {
        setActiveNspModal(null);
        return;
      } else {
        setActiveNspModal(NSP_MODAL);
        return;
      }
    }

    const verifyNsp = async () => {
      if (!clientId || !showNspModal) {
        setActiveNspModal(null);
        return;
      }
      try {
        dispatch(setVerifyingNsp(true));
        const res = await axiosInstance.get(URL.verifyNsp, {
          params: { customer_id: clientId },
        });

        const isNspWithinLastSevenDays =
          !!res?.data?.data?.nsp_within_last_7days;

        if (isNspWithinLastSevenDays) {
          setActiveNspModal(CONFIRMATION_MODAL);
        } else {
          setActiveNspModal(NSP_MODAL);
        }
      } catch (error) {
        if (error?.response?.status === 400) {
          dispatch(
            addToast({
              msg: error?.response?.data?.status?.message,
              appearance: "error",
            })
          );
        } else {
          Bugsnag.notify(error);
          dispatch(
            addToast({
              msg: "Error verifying NSP status",
              appearance: "error",
            })
          );
        }
        setQueryParams(
          { clientId: null, clientName: null, showNspModal: null },
          "replaceIn"
        );
      } finally {
        dispatch(setVerifyingNsp(false));
      }
    };

    verifyNsp();
  }, [clientId, showNspModal, dispatch, setQueryParams]);

  return { activeNspModal, setActiveNspModal };
};

export default useNspVerification;
